<div class="product-container">
    <div class="image-container">
        <div class="image-checkbox">
            <mat-checkbox [checked]="selected" (change)="checkOption(index)" [disabled]="maxCount===3 && selected===false">
            </mat-checkbox>
        </div>
        <img *ngIf="product.image_link !== 'NA~NA'; else defaultImage"
            class="product-image"
            [src]="product.image_link"
            [alt]="product.ProductName">

        <ng-template #defaultImage>
            <img class="product-image"
                src="../../../assets/default_placeholder.png"
                alt="{{product.ProductName}}">
        </ng-template>
    </div>
    <div class="product-details">
        <div class="product-header">
            <a class="link-text" href="{{product.know_more}}" target="_blank">{{product.ProductName}}</a>
        </div>
        <div class="product-description-id">
            <span>
                Product ID
            </span>
            <span class="id-information">
                {{product.id}}
            </span>
        </div>
        <div class="product-availability-info">
            <div *ngIf="product.Stock_availability; else elseBlockForAvailability" style="color: green;">
                In Stock
            </div>
            <ng-template #elseBlockForAvailability>
                <span *ngIf="checkValue(product.Stock_availability)" style="color: red;">Out of Stock</span>
            </ng-template>
            <div>
                <a class="check-online-button-link" href="https://www.homedepot.com/s/{{product.ProductName}}" target="_blank" *ngIf="store==='HD'">
                    <app-link-button></app-link-button>
                </a>
                <a class="check-online-button-link" href="https://www.lowes.com/search?searchTerm={{product.ProductName}}" target="_blank" *ngIf="store==='LO'">
                    <app-link-button></app-link-button>
                </a>
                <a class="check-online-button-link" href="https://www.walmart.com/search?q={{product.ProductName}}" target="_blank" *ngIf="store==='WM'">
                    <app-link-button></app-link-button>
                </a>
                <a class="check-online-button-link" href="https://www.acehardware.com/search?query={{product.ProductName}}" target="_blank" *ngIf="store==='AC'||store==='ACE'">
                    <app-link-button></app-link-button>
                </a>
                <a class="check-online-button-link" href="https://www.costco.com/s?keyword={{product.ProductName}}" target="_blank" *ngIf="store==='COS'">
                    <app-link-button></app-link-button>
                </a>
            </div>
        </div>
        <div class="product-description-state">
            <span>
                State Exclusion
            </span>
            <span class="state-information">
                {{product.State_Exclusions ? product.State_Exclusions : 'None'}}
            </span>
        </div>
        <div class="product-description-availability">
            <span>
                Store Availability
            </span>
            <span class="availability-information">
                {{product.Account_Availability_Original}}
            </span>
        </div>
        <div class="button-container">
            <button (click)="gotoSearch(product.ProductName)" class="view-similar-button">
                View Similar
            </button>
            <button class="ask-more-button" (click)="expandPanel()">
                <span class="material-symbols-outlined ask-more-button-icon">
                    feedback
                </span>
                Ask More
            </button>
        </div>
    </div>
</div>